import React, { FunctionComponent } from "react";
import { Theme, makeStyles, SliderProps, Slider } from "@material-ui/core";

const RAIL_HEIGHT = 7;
const MIN_VALUE = 0;
const MAX_VALUE = 100;
const STEP = 20;

interface INutrientIndicatorSliderStyleProps {
  color: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: theme.palette.secondary.main,
    height: RAIL_HEIGHT,
  },
  thumb: {
    display: "none",
  },
  track: {
    height: RAIL_HEIGHT,
    borderRadius: 4,
    backgroundColor: (props: INutrientIndicatorSliderStyleProps) => props.color,
  },
  rail: {
    height: RAIL_HEIGHT,
    borderRadius: 4,
    backgroundColor: theme.palette.grey["200"],
  },
  markLabel: {
    width: 1,
    height: RAIL_HEIGHT,
    backgroundColor: theme.palette.background.default,
    "&.MuiSlider-mark": {
      // hide all marks
      display: "none",
    },
    "&.MuiSlider-mark ~ .MuiSlider-mark": {
      // show all marks but the first one
      display: "block",
    },
  },
}));

interface INutrientIndicatorSliderProps extends SliderProps {
  value: number;
  sliderColor: string;
}

export const NutrientIndicatorSlider: FunctionComponent<INutrientIndicatorSliderProps> = (props) => {
  const { value, sliderColor, marks, ...rest } = props;
  const classes = useStyles({ color: sliderColor });
  const absValue = Math.abs(value);
  return (
    <Slider
      min={MIN_VALUE}
      step={STEP}
      max={MAX_VALUE}
      value={absValue}
      marks
      classes={{
        root: classes.root,
        thumb: classes.thumb,
        track: classes.track,
        rail: classes.rail,
        mark: classes.markLabel,
      }}
      {...rest}
    />
  );
};
